import React, { useContext, useEffect, useState } from 'react'
import { AddressChangeContext } from '../AddressContext/AddressChangeContext'
import NewAddress from './NewAddress'
import { NewAddressContextComp } from '../AddressContext/NewAddressContext'
import Note from '../Note/Note'
import AddressChangeBtnNav from '../AddressChangeBtnNav/AddressChangeBtnNav'
import ValidationModal from 'components/ValidationModal'
import TextField from '../CustomInputs/TextField/TextField'

const ChangeAddressMain = () => {
    const context = useContext(AddressChangeContext)
    var policyAddressInfo = context?.addressChangeClass?.policyAddressFields
    const [isLargeScreen, setIsLargeScreen] = useState(false);

    // Update state based on window size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsLargeScreen(true);
            } else {
                setIsLargeScreen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            <h5 className='text-primary text-center fw-bold mb-4'>CHANGE ADDRESS</h5>

            {/* Current Address */}
            <div style={{ marginRight: isLargeScreen ? '50px' : '0' }}>
                <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>
                <TextField
                    label='Current Address'
                    staticField={true}
                    policyAddressInfo={policyAddressInfo}
                />
                </div>

                <NewAddressContextComp>
                    {/* <div className={`${isLargeScreen&&"px-5"}`}> */}
                    <NewAddress/>
                    {/* </div> */}

                    <hr />
                    <Note />
                    <hr />

                    <AddressChangeBtnNav />
                </NewAddressContextComp>
            </div>

            <ValidationModal
                title={context.validationTitle}
                show={context.showModal}
                handleClose={() => context.setShowModal(false)}
                validationMsg={context.validationMsg}
            />
        </div>
    )
}

export default ChangeAddressMain